var map = {
	"./de.json": 104,
	"./en.json": 105,
	"./fr.json": 106,
	"./ja.json": 107,
	"./ko.json": 108,
	"./pt-br.json": 109,
	"./ru.json": 110,
	"./zh.json": 111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 103;